import mark from '#/lib/mark.json'

/*
  The Contour mark, standard density.

  Geometry comes from src/lib/mark.json, which scripts/build-icons.cjs reads as
  well, so the mark on screen and the mark on the home screen cannot drift
  apart.

  The rings are drawn in currentColor rather than a fixed ink, which is the
  mono colourway from the mark's own spec. That is what makes it survive the
  Appearance switch: on a dark ground the lines come back light without a
  second asset and without knowing which mode is on. Only the spot height is
  fixed, because the accent is the one part that is supposed to stay the
  accent.

  Sizes follow the spec's ladder: the standard density is drawn from 24 to
  96px. Below that it fills in and wants the compact variant, which the app has
  no use for yet — the favicon is generated instead.
*/

export function Logo({ size = 28, title }: { size?: number; title?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={mark.viewBox}
      width={size}
      height={size}
      fill="none"
      // Decorative beside the wordmark; named only where it stands alone.
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      style={{ display: 'block', flex: '0 0 auto' }}
    >
      {mark.rings.map((r) => (
        <path
          key={r.d.slice(0, 24)}
          d={r.d}
          fill="none"
          stroke="currentColor"
          strokeWidth={r.w}
        />
      ))}
      <circle cx={mark.spot.cx} cy={mark.spot.cy} r={mark.spot.r} fill={mark.accent} />
    </svg>
  )
}
